export type V3UsageRights = {
  '@type': string;
  content: V3UsageRightsContent[];
  firstPage: boolean;
  hasContent: boolean;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  lastPage: boolean;
  number: number;
  numberOfElements: number;
  pageSize: number;
  sort: V3UsageRightsSort;
  totalElements: number;
  totalPages: number;
};

export type V3UsageRightsContent = {
  '@type': V3UsageRightsType;
  comment: V3UsageRightsComment;
  createdAt: Date;
  crewId: number;
  id: number;
  legacyGroupId: number;
  maxCrewSize: number;
  productId: number;
  subscriptionId: null;
  type: V3UsageRightsTypeEnum;
  validFrom: Date;
  validUntil: Date;
};

export enum V3UsageRightsType {
  COMCrewmeisterUsageRight = 'com.crewmeister/UsageRight',
}

export enum V3UsageRightsComment {
  AdminAddUsageRight = 'admin/add_usage_right',
  CustomerStartTrial = 'customer/start_trial',
}

export enum V3UsageRightsTypeEnum {
  Manual = 'MANUAL',
  Trial = 'TRIAL',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export type V3UsageRightsSort = {
  '@type': string;
  orders: any[];
};
